export default __webpack_public_path__ + "static/whatYouGet-2d98905005f8f92a34c681906411238c.png";